/**
 * The largest file any client (web, mobile, or the external API) may upload
 * via a GCS signed upload URL, regardless of category. A direct multipart
 * upload has its own, separate size limit (e.g. `MAX_FILE_SIZE` in the v1
 * external API's file upload endpoint).
 */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 250 * 1024 * 1024;

/**
 * The largest HEIC/HEIF image we will re-encode to JPEG. Well above any phone
 * camera's output, and far below the point at which a pure-JS decode of the
 * whole image in memory threatens the process running it.
 */
export const MAX_CONVERTIBLE_IMAGE_SIZE_BYTES = 25 * 1024 * 1024;
